var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicateThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9863 0.686646H2.74637C1.99104 0.686646 1.37305 1.30464 1.37305 2.05996V11.6732H2.74637V2.05996H10.9863V0.686646ZM13.0463 3.43328H5.493C4.73768 3.43328 4.11968 4.05128 4.11968 4.8066V14.4198C4.11968 15.1752 4.73768 15.7931 5.493 15.7931H13.0463C13.8016 15.7931 14.4196 15.1752 14.4196 14.4198V4.8066C14.4196 4.05128 13.8016 3.43328 13.0463 3.43328ZM13.0463 14.4198H5.493V4.8066H13.0463V14.4198Z",
    fill: "#ADADAD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4798,
    height: 16.4798,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateThumb);
export default __webpack_public_path__ + "static/media/duplicate-thumb.a29b9f4a06bbf913a6090d8803b8a281.svg";
export { ForwardRef as ReactComponent };